import { default as JSCookie } from 'js-cookie';

const USER_ACCESS_TOKEN = 'access_token';
const CLIENT_ACCESS_TOKEN = 'client_access_token';
const ACCOUNT_TOKEN = 'account_token';

export interface IToken {
	access_token: string;
	user?: {
		id: number;
	};
	contact?: {
		id: number;
	};
}

export interface IAccessTokenPayload {
	sub: number;
	name: string;
	username: string;
	client?: {
		id?: number;
		fantasy_name?: string;
		cnpj?: string;
		system_configs?: {
			moduloAuditoriaAtivado: boolean;
			processoFluxoUnicoAtivado: boolean;
			supplyReturnAtivado: boolean;
		};
	};
	permissions: Record<string, boolean>;
	type: 'User' | 'Client' | 'Shipowner';
	iat?: number;
	exp?: number;
}

abstract class Cookies {
	static getAccessToken(): IToken {
		const accessToken = JSON.parse(JSCookie.get(USER_ACCESS_TOKEN) || '{}');
		return accessToken;
	}

	static getAccessTokenPayload(): IAccessTokenPayload | undefined {
		try {
			const token = this.getAccessToken().access_token;
			const payload = token?.split('.')[1];
			if (!payload) return undefined;

			const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
			const base64ComPadding = base64.padEnd(
				base64.length + ((4 - (base64.length % 4)) % 4),
				'='
			);
			const bytes = Uint8Array.from(
				window.atob(base64ComPadding),
				(caractere) => caractere.charCodeAt(0)
			);

			return JSON.parse(new TextDecoder().decode(bytes));
		} catch (error) {
			return undefined;
		}
	}

	static setAccessToken(token: IToken, keepConnected: boolean) {
		const expires = keepConnected ? 30 : undefined;
		const isSecure = window.location.protocol === 'https:';

		JSCookie.set(USER_ACCESS_TOKEN, JSON.stringify(token), {
			expires,
			path: '/',
			secure: isSecure,
			sameSite: 'Strict',
		});
	}

	static remove() {
		JSCookie.remove(USER_ACCESS_TOKEN, { path: '/' });
	}

	static getClientAccessToken(): IToken {
		const accessToken = JSON.parse(
			JSCookie.get(CLIENT_ACCESS_TOKEN) || '{}'
		);
		return accessToken;
	}

	static setClientAccessToken(token: IToken, keepConnected: boolean) {
		const expires = keepConnected ? 30 : undefined;
		const isSecure = window.location.protocol === 'https:';

		JSCookie.set(CLIENT_ACCESS_TOKEN, JSON.stringify(token), {
			expires,
			path: '/',
			secure: isSecure,
			sameSite: 'Strict',
		});
	}

	static removeClient() {
		JSCookie.remove(CLIENT_ACCESS_TOKEN, { path: '/' });
	}

	static getAccount() {
		const accountToken = JSCookie.get(ACCOUNT_TOKEN) || '';
		return accountToken;
	}

	static setAccount(idAccount: number) {
		const isSecure = window.location.protocol === 'https:';
		JSCookie.set(ACCOUNT_TOKEN, String(idAccount), {
			path: '/',
			secure: isSecure,
			sameSite: 'Strict',
		});
	}

	static removeAccount() {
		JSCookie.remove(ACCOUNT_TOKEN, { path: '/' });
	}

	static clear() {
		JSCookie.remove(USER_ACCESS_TOKEN);
		JSCookie.remove(ACCOUNT_TOKEN);
		JSCookie.remove(CLIENT_ACCESS_TOKEN);
	}
}

export default Cookies;
